import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Link as MuiLink } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { AppRoutePath } from 'router/Routes';

export type AppLinkProps = {
	to: AppRoutePath;
	i18nLabelKey: string;
	onClick?: () => void;
};

const AppLink: FC<AppLinkProps> = ({ to, i18nLabelKey, onClick }) => {
	const { t } = useTranslation('navigation');

	return (
		<MuiLink
			to={to}
			component={Link}
			color="secondary"
			underline="none"
			onClick={onClick}
		>
			{t(i18nLabelKey as any)}
		</MuiLink>
	);
};

export default AppLink;
